import { Controller } from 'stimulus'

export default class extends Controller {
  static values = {
    rememberStateLocalStorageKey: String,
    autofocusOnOpen: Boolean,
  }

  contentToggled(e) {
    const isCollapsed = !e.detail.visible

    this.turnChevron(isCollapsed)

    if (this.hasRememberStateLocalStorageKeyValue) {
      localStorage.setItem(this.rememberStateLocalStorageKeyValue, isCollapsed)
    }

    if (!isCollapsed && this.autofocusOnOpenValue) this.focusFirstInput()
  }

  focusFirstInput() {
    this.element
      .querySelector(
        '.js-content input:not([type=hidden]), .js-content textarea'
      )
      ?.focus()
  }

  turnChevron(isCollapsed) {
    this.element
      .querySelector('.js-chevron')
      .classList.toggle('fa-rotate-90', !isCollapsed)
  }
}
